import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { clsJoin } from '@/utils'
import { SubscriptionMessages } from './components'
import { PlanClasses, PlanLabel } from './constants'
import css from './styles.module.css'

interface Props extends React.PropsWithChildren {
  planId: string
  onSwitch: () => void
  canceled: boolean
  messages: string[]
}

export const PlanCard: React.FC<Props> = ({
  messages,
  planId,
  onSwitch,
  canceled,
  children,
}) => {
  const className = clsJoin(css.plan_card, PlanClasses[planId])

  return (
    <div className={className}>
      <div className={css.header}>
        <div className={css.left}>
          <span className={css.title}>{PlanLabel[planId]}</span>
          {canceled && <span className={css.canceled}>Canceled</span>}
        </div>
        <Button size="medium" label="Switch plan" onClick={onSwitch} />
      </div>

      <div className={css.body}>
        <SubscriptionMessages messages={messages} />
        {children}
      </div>
    </div>
  )
}
